const Banners = [
  {
    to: "/narzedzia/kalkulator-emisji-co2",
    cta: "widgets:nitrogenCalculator.btn",
    title: "widgets:sidebar.cftWidget.p",
    desc: "widgets:sidebar.cftWidget.cta",
    cover: require("../../../assets/img/baner_360x360.png"),
  },
  {
    to: "/artykuly/zielone-zmiany",
    cta: "widgets:readMore",
    title: "widgets:sidebar.greenChangesWidget.p",
    desc: "",
    cover: require("../../../assets/img/widgets/zielone.jpg"),
  },
  {
    to: "/artykuly/dla-kobiet",
    cta: "landingPage:follow.btn",
    title: "widgets:sidebar.articlesHeelsWidget.h",
    desc: "",
    cover: require("../../../assets/img/widgets/obcasy.jpg"),
  },
  {
    to: "/nieruchomosci",
    cta: "widgets:realEstate.btn",
    title: "widgets:realEstate.title",
    desc: "",
    cover: require("../../../assets/img/nieruchomosci.jpeg"),
  },
  {
    to: "/nowy-polski-pomidor",
    cta: "widgets:nowyPolskiPomidor.btn",
    title: "widgets:nowyPolskiPomidor.title",
    desc: "widgets:nowyPolskiPomidor.subtitle",
    cover: require("../../../assets/img/widgets/nowy-polski-pomidor.png"),
  },
  {
    to: "/kalkulator-zuzycia-azotu",
    cta: "widgets:nitrogenCalculator.btn",
    title: "widgets:nitrogenCalculator.title",
    desc: "",
    cover: require("../../../assets/img/widgets/cows.jpg"),
  },
];

export default Banners;
